(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cloverse-loadout"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    document.querySelectorAll('details[data-cloverse-sort-dropdown][open]').forEach((d) => {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  document.querySelectorAll('.cloverse-loadout').forEach((root) => {
    const grid = root.querySelector('[data-cloverse-grid]');
    const inputs = Array.from(root.querySelectorAll('.cloverse-facet__input'));
    const empty = root.querySelector('[data-cloverse-empty]');
    const countEl = root.querySelector('[data-cloverse-count]');
    const chipsBox = root.querySelector('[data-cloverse-chips]');
    const clearBtns = root.querySelectorAll('[data-cloverse-clear]');
    const toggleCount = root.querySelector('[data-cloverse-toggle-count]');

    // Price
    const price = root.querySelector('[data-cloverse-price]');
    const priceMin = price && price.querySelector('[data-price-min]');
    const priceMax = price && price.querySelector('[data-price-max]');
    const priceFill = price && price.querySelector('[data-price-fill]');
    const priceLowLbl = price && price.querySelector('[data-price-low]');
    const priceHighLbl = price && price.querySelector('[data-price-high]');
    const priceCeiling = price ? Number(price.dataset.max) : 0;
    const symbol = price ? price.dataset.symbol || '' : '';

    // Drawer
    const setDrawer = (open) => {
      root.classList.toggle('is-filters-open', open);
      document.documentElement.classList.toggle('cloverse-no-scroll', open);
      const t = root.querySelector('[data-cloverse-filter-toggle]');
      if (t) t.setAttribute('aria-expanded', String(open));
    };
    root.querySelectorAll('[data-cloverse-filter-toggle]').forEach((b) => b.addEventListener('click', () => setDrawer(!root.classList.contains('is-filters-open'))));
    root.querySelectorAll('[data-cloverse-filter-close]').forEach((el) => el.addEventListener('click', () => setDrawer(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setDrawer(false); });

    if (!grid) return;
    const cells = Array.from(grid.querySelectorAll('.cloverse-loadout__cell'));

    const priceActive = () => price && (Number(priceMin.value) > 0 || Number(priceMax.value) < priceCeiling);

    const renderChips = () => {
      if (!chipsBox) return;
      const chips = [];
      inputs.forEach((i) => {
        if (i.checked) chips.push({ label: i.dataset.facetLabel || i.dataset.facetValue, clear: () => { i.checked = false; } });
      });
      if (priceActive()) {
        chips.push({ label: `${symbol}${priceMin.value} – ${symbol}${priceMax.value}`, clear: () => { priceMin.value = 0; priceMax.value = priceCeiling; } });
      }
      chipsBox.innerHTML = '';
      chips.forEach((c) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cloverse-loadout__chip';
        btn.innerHTML = `<span>${c.label}</span><svg viewBox="0 0 16 16" width="12" height="12" fill="none"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>`;
        btn.addEventListener('click', () => { c.clear(); apply(); });
        chipsBox.appendChild(btn);
      });
      chipsBox.hidden = chips.length === 0;
      const activeCount = chips.length;
      clearBtns.forEach((b) => { b.hidden = activeCount === 0; });
      if (toggleCount) { toggleCount.hidden = activeCount === 0; toggleCount.textContent = activeCount; }
    };

    const apply = () => {
      const groups = {};
      inputs.forEach((i) => { if (i.checked) { (groups[i.dataset.facetGroup] = groups[i.dataset.facetGroup] || []).push(i.dataset.facetValue); } });
      const keys = Object.keys(groups);
      const lo = price ? Number(priceMin.value) : 0;
      const hi = price ? Number(priceMax.value) : Infinity;
      let visible = 0;
      cells.forEach((cell) => {
        const facets = (cell.dataset.facets || '').split(/\s+/).filter(Boolean);
        const facetMatch = keys.every((g) => groups[g].some((v) => facets.includes(v)));
        const pr = Number(cell.dataset.price || 0);
        const priceMatch = !price || (pr >= lo && pr <= hi);
        const match = facetMatch && priceMatch;
        cell.hidden = !match;
        if (match) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
      grid.hidden = visible === 0;
      if (countEl) countEl.textContent = visible;
      renderChips();
    };

    inputs.forEach((i) => i.addEventListener('change', apply));
    clearBtns.forEach((btn) => btn.addEventListener('click', (e) => {
      e.preventDefault();
      inputs.forEach((i) => (i.checked = false));
      if (price) { priceMin.value = 0; priceMax.value = priceCeiling; updatePrice(); }
      apply();
    }));

    // Price slider
    function updatePrice() {
      if (!price) return;
      let lo = Number(priceMin.value);
      let hi = Number(priceMax.value);
      if (lo > hi) { const t = lo; lo = hi; hi = t; }
      if (priceLowLbl) priceLowLbl.textContent = symbol + lo;
      if (priceHighLbl) priceHighLbl.textContent = symbol + hi;
      if (priceFill && priceCeiling > 0) {
        priceFill.style.left = (lo / priceCeiling) * 100 + '%';
        priceFill.style.right = (100 - (hi / priceCeiling) * 100) + '%';
      }
    }
    if (price) {
      [priceMin, priceMax].forEach((r) => {
        r.addEventListener('input', updatePrice);
        r.addEventListener('change', apply);
      });
      updatePrice();
    }

    // Client-side sort
    const sortLabel = root.querySelector('[data-cloverse-sort-label]');
    root.querySelectorAll('[data-sort]').forEach((opt) => {
      opt.addEventListener('click', () => {
        const dir = opt.dataset.sort;
        cells.slice().sort((a, b) => {
          const ta = a.dataset.title || '', tb = b.dataset.title || '';
          return dir === 'asc' ? ta.localeCompare(tb) : tb.localeCompare(ta);
        }).forEach((c) => grid.appendChild(c));
        root.querySelectorAll('[data-sort]').forEach((o) => o.classList.toggle('is-active', o === opt));
        if (sortLabel) sortLabel.textContent = dir === 'asc' ? 'A – Z' : 'Z – A';
        const dd = opt.closest('details[data-cloverse-sort-dropdown]');
        if (dd) dd.removeAttribute('open');
      });
    });

    // Pre-select filters from ?category=/?size=… query params + data-preselect
    const params = new URLSearchParams(window.location.search);
    const qpre = [];
    ['category', 'gender', 'size', 'color', 'avail'].forEach((k) => {
      const v = params.get(k);
      if (v) v.split(',').forEach((x) => qpre.push(k + ':' + x.trim().toLowerCase()));
    });
    const dpre = (root.getAttribute('data-preselect') || '').split(/\s+/).filter(Boolean);
    const preselects = qpre.concat(dpre);
    if (preselects.length) {
      inputs.forEach((i) => {
        if (preselects.includes(i.dataset.facetValue)) {
          i.checked = true;
          const d = i.closest('details');
          if (d) d.open = true;
        }
      });
    }
    apply();
    // A collection-derived preselect that matches nothing shouldn't show an empty grid
    // (an explicit ?category= deep-link still shows its empty state).
    if (dpre.length && qpre.length === 0 && grid.hidden) {
      inputs.forEach((i) => { if (dpre.includes(i.dataset.facetValue)) i.checked = false; });
      apply();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
